<ng-container *ngIf="!BetIdActive">
  <div class="text-end">
    <app-pagination
      *ngIf="winloseItems"
      [page]="currentPage"
      [limit]="winloseItems?.limitRow"
      [total]="winloseItems?.resultRow"
      (valueChange)="pageChanged($event)"
    >
    </app-pagination>
  </div>
  <div class="p-2 bg-primary" style="border-radius: 4px">
    pt = {{ "AGENT_FIGHTING_PERCENTAGE_ACCORDING_TO_LEVEL" | translate }} / com =
    {{ "COMMISSION_OF_ITEM" | translate }}
  </div>
  <div class="table-responsive">
    <table class="table table-hover text-nowrap">
      <thead>
        <tr>
          <th rowspan="2">#</th>
          <th rowspan="2">{{ "INFORMATION" | translate }}</th>
          <th rowspan="2">{{ "LIST" | translate }}</th>
          <th rowspan="2">{{ "DETAILS" | translate }}</th>
          <th rowspan="2">{{ "STATUS" | translate }}</th>
          <th rowspan="2">{{ "BET_AMOUNT" | translate }}</th>
          <th rowspan="2">{{ "ACTUAL_BET_AMOUNT" | translate }}</th>
          <th>{{ "MEMBER" | translate }}</th>
          <th *ngIf="currentAgent?.type_agent <= 4">Agent</th>
          <th *ngIf="currentAgent?.type_agent <= 3">Agent Master</th>
          <th *ngIf="currentAgent?.type_agent <= 2">Agent Senior</th>
          <th *ngIf="currentAgent?.type_agent <= 1">Shareholder</th>
          <th [ngClass]="{ 'bt-more': showPercentAdmin }">
            Company
            <a class="btn-more" *ngIf="isAdmin" (click)="showPercentAdmin = !showPercentAdmin">
              <i class="bi bi-three-dots-vertical"></i>
            </a>
          </th>
          <th *ngIf="showPercentAdmin" class="bt-more">System</th>
          <th *ngIf="showPercentAdmin" class="bt-more">API</th>
        </tr>
        <tr>
          <th>Win Lose</th>
          <th *ngIf="currentAgent?.type_agent <= 4">Win Lose</th>
          <th *ngIf="currentAgent?.type_agent <= 3">Win Lose</th>
          <th *ngIf="currentAgent?.type_agent <= 2">Win Lose</th>
          <th *ngIf="currentAgent?.type_agent <= 1">Win Lose</th>
          <th>Win Lose</th>
          <th *ngIf="showPercentAdmin">Win Lose</th>
          <th *ngIf="showPercentAdmin">Win Lose</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of winloseItems?.items; let i = index">
          <td>{{ i + 1 }}</td>
          <!-- ข้อมูล -->
          <td class="text-start">
            <div class>
              <strong
                ><u>{{ item.betId }}</u></strong
              >
              <a class="ms-2" href="javascript:;" [appCopyToClipboard]="item.betId || ''">
                <i class="fas fa-copy"></i>
              </a>
            </div>
            <small class="d-block opacity-50" *ngIf="item.gameBetId">({{ item.gameBetId }})</small>
            <div class>Bet time: {{ item.timeBet | date : "dd/MM HH:mm:ss" }}</div>
            <div class>Settle time: {{ item.timeSettle | date : "dd/MM HH:mm:ss" }}</div>
            <div class>Ip: {{ item.Ip }}</div>

            <div class="mt-2" *ngIf="isAdmin">
              <hr class="mb-1" />
              <!-- *ngIf="item.gameType?.toLowerCase() === 'casino'" -->
              <a class="link-primary btn-sm me-2" (click)="requestUpdateWinLoseDetail(item)">
                <i class="bi bi-pencil-square"></i> {{ "EDIT" | translate }} W/L
              </a>
              <a class="link-info btn-sm" (click)="requestUpdateWinLoseDetail(item)">
                <i class="bi bi-send"></i> {{ "SEND_CALLBACK" | translate }}
              </a>
              <a class="link-danger btn-sm" (click)="fixMakeBetCancel(item)" *ngIf="item.gameType == 'sport' && item.gameResult == 'RUNNING'">
                <i class="bi bi-x-circle"></i> {{ "CANCEL BET" | translate }}
              </a>
            </div>
          </td>
          <!-- รายการ -->
          <td class="text-start">
            <ng-container *ngIf="item.gameType == 'sport'">
              <ng-container *ngIf="item.winlose_detail_sports">
                <div [ngClass]="{ 'text-decoration-line-through': item.gameResult == 'CANCEL' }">
                  <span
                    class="d-block-inline border px-3 py-1 bg-primary"
                    [ngClass]="{ 'text-decoration-line-through': item.gameResult == 'CANCEL' }"
                  >
                    <i class="bi bi-trophy"></i> League :
                    {{ item.winlose_detail_sports[0].league || "no league" }}
                  </span>
                </div>
                <div
                  class="border-start"
                  [ngClass]="{ 'text-decoration-line-through': item.gameResult == 'CANCEL' }"
                >
                  <span
                    class="ps-2 text-primary"
                    [ngClass]="{ 'text-decoration-line-through': item.gameResult == 'CANCEL' }"
                  >
                    {{ item.winlose_detail_sports[0].match.split(" vs ")[0] }}
                  </span>
                  <div class="ps-2">-vs-</div>
                  <span
                    class="ps-2 text-danger"
                    [ngClass]="{ 'text-decoration-line-through': item.gameResult == 'CANCEL' }"
                  >
                    {{ item.winlose_detail_sports[0].match.split(" vs ")[1] }}
                  </span>
                </div>
                <div [ngClass]="{ 'text-decoration-line-through': item.gameResult == 'CANCEL' }">
                  KickOff Time :
                  {{ item.winlose_detail_sports[0].kickOffTime | date : "dd/MM HH:mm:ss" }}
                </div>
              </ng-container>
              <ng-container *ngIf="!item.winlose_detail_sports">
                <div [ngClass]="{ 'text-decoration-line-through': item.gameResult == 'CANCEL' }">
                  {{ "NO_BET_RECORDS_FOUND" | translate }} ({{ item.gameProvider }})
                </div>
                <div [ngClass]="{ 'text-decoration-line-through': item.gameResult == 'CANCEL' }">
                  {{ "IN_TIME" | translate }} {{ item.timeBet | date : "dd/MM HH:mm:ss" }}
                </div>
                <small class="d-block opacity-50" *ngIf="item.gameResult != 'CANCEL'">
                  <i class="bi bi-hourglass-split"></i>
                  {{ "BECAUSE_GAME_RESULT_IS_PENDING" | translate }}
                </small>
                <small class="d-block opacity-50" *ngIf="item.gameResult == 'CANCEL'">
                  <i class="bi bi-x-circle"></i>
                  {{ "BECAUSE_GAME_BET_HAS_BEEN_CANCELED" | translate }}
                </small>
                <button
                  class="btn btn-sm btn-outline-primary mt-2"
                  (click)="saveWinloseDetail(item.betId)"
                  *ngIf="item.gameResult != 'CANCEL' && item.gameResult != 'RUNNING'"
                >
                  Fecth detail macth
                </button>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="item.winlose_detail_tf">
              <div class>{{ "GAME_NAME" | translate }}: {{ item.gameName }}</div>
              <div class>{{ "PROVIDERS" | translate }}: {{ item.gameProvider }}</div>
            </ng-container>
            <ng-container
              *ngIf="
                userSameDetail.includes(item.gameType) || userSameSlotDetail.includes(item.gameType)
              "
            >
              <div class>{{ "GAME_NAME" | translate }}: {{ item.gameName }}</div>
              <div class>{{ "PROVIDERS" | translate }}: {{ item.gameProvider }}</div>
            </ng-container>
            <ng-container *ngIf="item.gameType == 'lotto'">
              <div class>{{ "GAME_NAME" | translate }}: LOTTO</div>
              <div class>{{ "PROVIDERS" | translate }}: {{ item.gameProvider }}</div>
            </ng-container>
          </td>
          <!-- รายละเอียด -->
          <td class="text-start">
            <ng-container *ngIf="item.gameType == 'sport'">
              <ng-container *ngIf="item.winlose_detail_sports">
                <div [ngClass]="{ 'text-decoration-line-through': item.gameResult == 'CANCEL' }">
                  <div class>{{ item.gameProvider }}</div>
                  <div class>
                    <u class="text-success">({{ item.gameSportsType }})</u> x {{ item.gameOdds }}
                  </div>
                  <a
                    [ngClass]="{ 'text-decoration-line-through': item.gameResult == 'CANCEL' }"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#detail-sports"
                    aria-controls="offcanvasRight"
                    class="link-primary"
                    (click)="openPrint(item)"
                  >
                    <i class="fas fa-print"></i> Print ({{
                      item.winlose_detail_sports.length || 0
                    }}
                    {{ "LIST" | translate }})
                  </a>
                </div>
              </ng-container>
              <ng-container *ngIf="!item.winlose_detail_sports">
                <div [ngClass]="{ 'text-decoration-line-through': item.gameResult == 'CANCEL' }">
                  <div class>{{ item.gameProvider }}</div>
                  <div class>
                    {{ item.gameSportsType }}
                    <small class="d-block opacity-50">
                      {{ "WAITING_FOR_RESULT" | translate }}
                    </small>
                  </div>
                </div>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="item.winlose_detail_tf">
              <div class>{{ item.gameProvider }}</div>
              <div class>
                <u class="text-success">({{ item.gameName }})</u> x {{ item.gameOdds }}
              </div>
              <a
                [ngClass]="{ 'text-decoration-line-through': item.gameResult == 'CANCEL' }"
                data-bs-toggle="offcanvas"
                data-bs-target="#detail-esports"
                aria-controls="offcanvasRight"
                class="link-primary"
                (click)="openPrintEsports(item)"
              >
                <i class="fas fa-print"></i> Print
              </a>
            </ng-container>

            <ng-container *ngIf="item.gameType == 'lotto'">
              <div class>{{ item.gameProvider }}</div>
              <div class>
                <u class="text-success">({{ item.gameLottoType }})</u> x
                {{ item.winlose_detail_lotto.length }}
              </div>
              <a
                [ngClass]="{ 'text-decoration-line-through': item.gameResult == 'CANCEL' }"
                data-bs-toggle="offcanvas"
                data-bs-target="#detail-lotto"
                aria-controls="offcanvasRight"
                class="link-primary"
                (click)="openPrintLotto(item)"
              >
                <i class="fas fa-print"></i> Print
              </a>
            </ng-container>

            <ng-container
              *ngIf="
                userSameDetail.includes(item.gameType) || userSameSlotDetail.includes(item.gameType)
              "
            >
              <div>
                <strong>
                  <a class="link-primary" (click)="onSetActiveDetail(item.betId, item.gameType)">
                    +Detail: ({{
                      (item?.winlose_detail_slot_count || 0) +
                        (item?.winlose_detail_casino_count || 0) +
                        (item?.winlose_detail_game_card_count || 0) +
                        (item?.winlose_detail_cockfight_count || 0) +
                        (item?.winlose_detail_lotto_game_count || 0) +
                        (item?.winlose_detail_keno_count || 0)
                    }}
                    Item.)
                  </a>
                </strong>
              </div>
              <div>End : {{ item.timeSettle | date : "dd/MM HH:mm:ss" }}</div>
            </ng-container>
          </td>

          <!-- สถานะ -->
          <td>
            <ng-container
              *ngIf="
                item.gameType == 'sport' || item.gameType == 'esport' || item.winlose_detail_lotto
              "
            >
              <span class="text-primary" *ngIf="item.gameResult == 'RUNNING'">
                <img src="assets/loading-gif.gif" width="16px" /> {{ item.gameResult }}
              </span>
              <span class="text-success" *ngIf="item.gameResult == 'WIN'">{{
                item.gameResult
              }}</span>
              <span class="text-danger" *ngIf="item.gameResult == 'LOSE'">{{
                item.gameResult
              }}</span>
              <span class="text-info" *ngIf="item.gameResult == 'DRAW'">{{ item.gameResult }}</span>
              <span class="text-danger" *ngIf="item.gameResult == 'CANCEL'">{{
                item.gameResult
              }}</span>
            </ng-container>
            <ng-container
              *ngIf="
                userSameDetail.includes(item.gameType) || userSameSlotDetail.includes(item.gameType)
              "
            >
              <span *ngIf="item.winLose > 0" class="text-success">WIN</span>
              <span *ngIf="item.winLose < 0" class="text-danger">LOSE</span>
              <span *ngIf="item.winLose == 0" class="text-info">DRAW</span>
            </ng-container>
          </td>

          <!-- จำนวนเดิมพัน -->
          <td>
            <div class="text-end ff-number">
              {{ item.betAmt | number : "1.2-2" }}
            </div>
          </td>
          <!-- จำนวนเดิมพันจริง -->
          <td>
            <div class="text-end ff-number">
              {{ item.betValidAmt || 0 | number : "1.2-2" }}
            </div>
          </td>

          <!-- Member Win Lose -->
          <td>
            <div class="text-end ff-number">
              <span [appNumberColor]="item.winLose | number : '1.2-2'"></span>
            </div>
            <div class="d-block badge-com px-1 text-end">
              <span class="float-start">com</span>
              <span class="ff-number">0.00</span>
            </div>
            <div class="text-end ff-number">
              <span
                class="text-underline"
                [appNumberColor]="item.winLose | number : '1.2-2'"
              ></span>
            </div>
          </td>
          <!-- Agent Win Lose -->
          <td *ngIf="currentAgent?.type_agent <= 4">
            <div class="text-end ff-number">
              <span [appNumberColor]="item.wl_agent | number : '1.2-2'"></span>
            </div>
            <div class="d-block badge-com text-end">
              <span class="float-start">com</span>
              <span class="ff-number">0.00</span>
            </div>
            <div class="text-end ff-number">
              <span
                class="text-underline"
                [appNumberColor]="item.wl_agent | number : '1.2-2'"
              ></span>
            </div>
            <div class="d-block badge-com text-end opacity-50">
              <span class="float-start">pt</span>
              <span class="ff-number">{{ item.percent_agent }}%</span>
            </div>
          </td>
          <!-- Agent Master Win Lose -->
          <td *ngIf="currentAgent?.type_agent <= 3">
            <div class="text-end ff-number">
              <span [appNumberColor]="item.wl_master | number : '1.2-2'"></span>
            </div>
            <div class="d-block badge-com text-end">
              <span class="float-start">com</span>
              <span class="ff-number">0.00</span>
            </div>
            <div class="text-end ff-number">
              <span
                class="text-underline"
                [appNumberColor]="item.wl_master | number : '1.2-2'"
              ></span>
            </div>
            <div class="d-block badge-com text-end opacity-50">
              <span class="float-start">pt</span>
              <span class="ff-number">{{ item.percent_master }}%</span>
            </div>
          </td>
          <!-- Agent Senior Win Lose -->
          <td *ngIf="currentAgent?.type_agent <= 2">
            <div class="text-end ff-number">
              <span [appNumberColor]="item.wl_senior | number : '1.2-2'"></span>
            </div>
            <div class="d-block badge-com text-end">
              <span class="float-start">com</span>
              <span class="ff-number">0.00</span>
            </div>
            <div class="text-end ff-number">
              <span
                class="text-underline"
                [appNumberColor]="item.wl_senior | number : '1.2-2'"
              ></span>
            </div>
            <div class="d-block badge-com text-end opacity-50">
              <span class="float-start">pt</span>
              <span class="ff-number">{{ item.percent_senior }}%</span>
            </div>
          </td>
          <!-- Shareholder Win Lose -->
          <td *ngIf="currentAgent?.type_agent <= 1">
            <div class="text-end ff-number">
              <span [appNumberColor]="item.wl_shareholder | number : '1.2-2'"></span>
            </div>
            <div class="d-block badge-com text-end">
              <span class="float-start">com</span>
              <span class="ff-number">0.00</span>
            </div>
            <div class="text-end ff-number">
              <span
                class="text-underline"
                [appNumberColor]="item.wl_shareholder | number : '1.2-2'"
              ></span>
            </div>
            <div class="d-block badge-com text-end opacity-50">
              <span class="float-start">pt</span>
              <span class="ff-number">{{ item.percent_shareholder }}%</span>
            </div>
          </td>
          <!-- Company Win Lose -->
          <td>
            <div class="text-end ff-number">
              <span [appNumberColor]="item.wl_company | number : '1.2-2'"></span>
            </div>
            <div class="d-block badge-com text-end">
              <span class="float-start">com</span>
              <span class="ff-number">0.00</span>
            </div>
            <div class="text-end ff-number">
              <span
                class="text-underline"
                [appNumberColor]="item.wl_company | number : '1.2-2'"
              ></span>
            </div>
            <div class="d-block badge-com text-end opacity-50">
              <span class="float-start">pt</span>
              <span class="ff-number">{{ item.percent_company }}%</span>
            </div>
          </td>
          <td *ngIf="showPercentAdmin">
            <div class="text-end ff-number">
              <span [appNumberColor]="item.wl_system | number : '1.2-2'"></span>
            </div>
            <div class="d-block badge-com text-end">
              <span class="float-start">com</span>
              <span class="ff-number">0.00</span>
            </div>
            <div class="text-end ff-number">
              <span
                class="text-underline"
                [appNumberColor]="item.wl_system | number : '1.2-2'"
              ></span>
            </div>
            <div class="d-block badge-com text-end opacity-50">
              <span class="float-start">pt</span>
              <span class="ff-number">{{ item.percent_system }}%</span>
            </div>
          </td>
          <td *ngIf="showPercentAdmin">
            <div class="text-end ff-number">
              <span [appNumberColor]="item.wl_provider | number : '1.2-2'"></span>
            </div>
            <div class="d-block badge-com text-end">
              <span class="float-start">com</span>
              <span class="ff-number">0.00</span>
            </div>
            <div class="text-end ff-number">
              <span
                class="text-underline"
                [appNumberColor]="item.wl_provider | number : '1.2-2'"
              ></span>
            </div>
            <div class="d-block badge-com text-end opacity-50">
              <span class="float-start">pt</span>
              <span class="ff-number">{{ item.percent_provider }}%</span>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot *ngIf="winloseItems">
        <tr>
          <td colspan="5">Total {{ currentAgent.currency || "THB" }}</td>
          <td class="text-end">
            <span class="ff-number">
              {{ winloseItems?.total?.total_amount | number : "1.2-2" }}
            </span>
          </td>
          <td class="text-end">
            <span class="ff-number">
              {{ winloseItems?.total?.total_valid_amount | number : "1.2-2" }}
            </span>
          </td>
          <td class="text-end">
            <span
              class="ff-number text-underline"
              [appNumberColor]="winloseItems?.total?.total_wl_amount | number : '1.2-2'"
            ></span>
          </td>
          <td class="text-end" *ngIf="currentAgent?.type_agent <= 4">
            <span
              class="ff-number text-underline"
              [appNumberColor]="winloseItems?.total?.total_agent | number : '1.2-2'"
            ></span>
          </td>
          <td class="text-end" *ngIf="currentAgent?.type_agent <= 3">
            <span
              class="ff-number text-underline"
              [appNumberColor]="winloseItems?.total?.total_master | number : '1.2-2'"
            ></span>
          </td>
          <td class="text-end" *ngIf="currentAgent?.type_agent <= 2">
            <span
              class="ff-number text-underline"
              [appNumberColor]="winloseItems?.total?.total_senior | number : '1.2-2'"
            ></span>
          </td>
          <td class="text-end" *ngIf="currentAgent?.type_agent <= 1">
            <span
              class="ff-number text-underline"
              [appNumberColor]="winloseItems?.total?.total_shareholder | number : '1.2-2'"
            ></span>
          </td>
          <td class="text-end">
            <span
              class="ff-number text-underline"
              [appNumberColor]="winloseItems?.total?.total_company | number : '1.2-2'"
            ></span>
          </td>
          <td class="text-end" *ngIf="showPercentAdmin">
            <span
              class="ff-number text-underline"
              [appNumberColor]="winloseItems?.total?.total_system | number : '1.2-2'"
            ></span>
          </td>
          <td class="text-end" *ngIf="showPercentAdmin">
            <span
              class="ff-number text-underline"
              [appNumberColor]="winloseItems?.total?.total_provider | number : '1.2-2'"
            ></span>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>

  <div class="text-center mb-3">
    <div class *ngIf="winloseItems && !winloseItems?.items.length">{{ "NO_DATA" | translate }}</div>
    <div *ngIf="loadingWinlose"><span class="spinner-border"></span></div>
  </div>
  <app-pagination
    *ngIf="winloseItems"
    [page]="currentPage"
    [limit]="winloseItems?.limitRow"
    [total]="winloseItems?.resultRow"
    (valueChange)="pageChanged($event)"
  >
  </app-pagination>
  <app-winlose-detail-lotto [DetailLotto]="ActiveLottoDetail"></app-winlose-detail-lotto>
  <app-winlose-detail-sports [DetailSports]="ActiveSportDetail"></app-winlose-detail-sports>
  <app-winlose-detail-esports [DetaileSports]="ActiveESportDetail"></app-winlose-detail-esports>
</ng-container>

<app-winlose-detail-slot
  *ngIf="BetIdActive && GameTypeActive && userSameSlotDetail.includes(GameTypeActive)"
  [betId]="BetIdActive"
  [currency]="currentAgent?.currency || 'THB'"
  [gameType]="GameTypeActive"
>
</app-winlose-detail-slot>

<app-winlose-detail-casino
  *ngIf="BetIdActive && GameTypeActive && userSameDetail.includes(GameTypeActive)"
  [betId]="BetIdActive"
  [gameType]="GameTypeActive"
>
</app-winlose-detail-casino>
